// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3I_TG","title":"Header_title__3DOTv","side":"Header_side__3wSRv"};